var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mobile-naigation'), _vm._v(" "), _c('v-flex-container', {
    attrs: {
      "center": "",
      "stretch": ""
    }
  }, [_c('v-card-container', [_c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.xs.top",
      value: (3),
      expression: "3",
      modifiers: {
        "xs": true,
        "top": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.xs.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "xs": true,
        "bottom": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.md.left",
      value: (7),
      expression: "7",
      modifiers: {
        "md": true,
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.md.right",
      value: (7),
      expression: "7",
      modifiers: {
        "md": true,
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.xs.left",
      value: (2),
      expression: "2",
      modifiers: {
        "xs": true,
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.xs.right",
      value: (2),
      expression: "2",
      modifiers: {
        "xs": true,
        "right": true
      }
    }, {
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n                        Зарегистрируйтесь и получите все "), _c('br'), _vm._v(" инструменты\n                        для проверки клиента\n                    ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.md.left",
      value: (8),
      expression: "8",
      modifiers: {
        "md": true,
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.md.right",
      value: (8),
      expression: "8",
      modifiers: {
        "md": true,
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.xs.left",
      value: (2),
      expression: "2",
      modifiers: {
        "xs": true,
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.xs.right",
      value: (2),
      expression: "2",
      modifiers: {
        "xs": true,
        "right": true
      }
    }]
  }, [_c('register-form')], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (3),
      expression: "3",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n            Уже зарегистрированы?\n\n            "), _c('v-router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("\n                Войти в личный кабинет\n            ")])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab5be4d4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/Register/Register.vue
// module id = 855
// module chunks = 0